import { render, staticRenderFns } from "./campus-list-add.vue?vue&type=template&id=25bba5dc&scoped=true&"
import script from "./campus-list-add.vue?vue&type=script&lang=js&"
export * from "./campus-list-add.vue?vue&type=script&lang=js&"
import style0 from "./campus-list-add.vue?vue&type=style&index=0&id=25bba5dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25bba5dc",
  null
  
)

export default component.exports